import { Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { LogOut, Menu } from 'lucide-react';

import { ROLE_LABELS } from '../lib/shared';
import { RoleSwitch } from './RoleSwitch';
import { useAuth } from '../lib/auth';
import { formatDayLong } from '../lib/format';
import { Sidebar } from './Sidebar';
import { SectionSpinner } from './Spinner';
import { DemoBanner } from './DemoBanner';

export function Layout() {
  const { user, roles, logout } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Переход по ссылке на телефоне должен закрывать выдвижное меню.
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const roleNames = roles.map((role) => ROLE_LABELS[role]).join(' · ');

  return (
    <div className="flex min-h-screen flex-col">
      <DemoBanner />
      <header className="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200 bg-white px-3 py-2.5 sm:px-4">
        <button
          type="button"
          onClick={() => setMenuOpen(true)}
          aria-label="Открыть меню"
          className="rounded-md p-2 text-slate-600 hover:bg-slate-100 lg:hidden"
        >
          <Menu className="h-5 w-5" aria-hidden />
        </button>

        <div className="min-w-0">
          <p className="truncate text-base font-semibold text-brand-800">Parkline AI</p>
          <p className="truncate text-xs text-slate-500">{formatDayLong(new Date())}</p>
        </div>

        <div className="ml-auto flex items-center gap-3">
          <div className="hidden text-right sm:block">
            <p className="truncate text-sm font-medium text-slate-800">
              {user?.fullName ?? user?.login}
            </p>
            <p className="max-w-[260px] truncate text-xs text-slate-500" title={roleNames}>
              {roleNames || 'Роли не назначены'}
            </p>
          </div>
          <RoleSwitch />
          <button
            type="button"
            onClick={logout}
            className="flex items-center gap-2 rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-700 transition-colors hover:bg-slate-100"
          >
            <LogOut className="h-4 w-4" aria-hidden />
            <span className="hidden sm:inline">Выход</span>
          </button>
        </div>
      </header>

      <div className="flex flex-1">
        <Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
        <main className="min-w-0 flex-1 p-3 sm:p-4 lg:p-6">
          <Suspense fallback={<SectionSpinner />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
